// src/config.js

// Change this to your live server URL when you deploy!
export const BASE_URL = 'https://pickupdrop.dodigitals.in/api';